import { CmsProductCarouselWidgetItem } from '../widgets/product-carousel';

export const productsCroppedImages = [
  {
    productId: 'A4100',
    imageUrl:
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/a4100/A4100_scaled_wp.png',
    categoryKeys: ['all-products', 'watches'],
  },
  {
    productId: 'D450',
    imageUrl:
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/d450/D450_scaled_wp.png',
    categoryKeys: ['all-products', 'phones'],
  },
  {
    productId: 'D215',
    imageUrl:
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/d215/D215_scaled_wp.png',
    categoryKeys: ['all-products', 'phones'],
  },
  {
    productId: 'G450',
    imageUrl:
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/g450/G450_scaled_wp.png',
    categoryKeys: ['all-products', 'tablets'],
  },
  // legacy?
  {
    productId: 'C210',
    imageUrl: 'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/c210/c210-cropped.png',
    categoryKeys: [],
  },
  {
    productId: 'F07',
    imageUrl: 'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/f07/f07-cropped.png',
    categoryKeys: [],
  },
  {
    productId: 'F450',
    imageUrl: 'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/f450/f450-cropped.png',
    categoryKeys: [],
  },
  {
    productId: 'G430',
    imageUrl: 'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/g430/g430-cropped.png',
    categoryKeys: [],
  },
  {
    productId: 'I3399',
    imageUrl:
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/i3399/i3399-cropped.png',
    categoryKeys: [],
  },
  // Repurposed images, since these devices physically look the samce
  {
    productId: 'I3399A',
    imageUrl:
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/i3399/i3399-cropped.png',
    categoryKeys: [],
  },
  {
    productId: 'F210',
    imageUrl: 'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/f07/f07-cropped.png',
    categoryKeys: [],
  },
  {
    productId: 'D03',
    imageUrl:
      'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/products/d450/D450_scaled_wp.png',
    categoryKeys: [],
  },
] as CmsProductCarouselWidgetItem[];
